import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../../Core/Container';
import Ctas from '../../../../Core/Ctas';

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }
`;

export const Heading = styled.h2`
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  margin: auto;
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};
`;

export const OverflowContainer = styled.div`
  overflow-x: hidden;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  background-image: url(${({ $backgroundImage }) =>
    $backgroundImage ? $backgroundImage.asset.localImage.publicURL : ''});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &.carousel-banner-section {
    margin: -40px auto 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: -70px auto 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: -100px auto 0;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  &.center {
    margin: 1.5rem auto 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 1.5rem auto 0;
    }
  }
`;
